import { useCallback, useEffect, useState, useContext } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import { Dashboard } from '../pages/Dashboard';
import { ChooseArticles } from '../pages/ChooseArticles';
import { ContextChooseProvider } from '../pages/ChooseArticles/ContextChoose';
import { useActionParam, useSaveArticleOpti } from '../api/actions/action';
import { store } from '../redux/store';
import { LogView } from '../pages/LogView';
import { useGetSelecionados, useGetSelecionadosDetalhes } from '../api/controllers/artigo';
import ContextSearch from '../pages/Dashboard/ContextSearch';
import { useGetUsuario } from '../api/controllers/usuario';
import Loading from '../componentsNew/Loading';
import { ArtigoIA } from '@pages/ArtigoIA';
import { IntegracaoProvider } from '@pages/ArtigoIA/Context/IntegracaoContext';

export const ComponentRoute = ({ currentRoute, optiArticles, loading }) => {
  const [artigos, setArtigos] = useState([]);
  const [recadastrando, setRecadastrando] = useState(false);
  const [excluir, setExcluir] = useState(false);
  // const { mutate: getUserOpti, data: userOpti } = useAction()
  const { mutateAsync: obterSelecionados } = useGetSelecionadosDetalhes();
  const { mutateAsync } = useActionParam();
  const idBlog = useSelect(select => select(store).getBlogIdOpti());
  const idUsuario = useSelect(select => select(store).getUsuarioIdOpti());
  const { data: dataUser } = useGetUsuario(idUsuario || 0);
  const { data: dataIdsSelecionados, isLoading } = useGetSelecionados(idBlog);
  const { mutateAsync: saveArticleOpti, isSuccess } = useSaveArticleOpti();

  const { setGratuito } = useContext(ContextSearch);
  const { dataPlanoUsuario } = useContext(ContextSearch)

  async function populatePost() {
    if (optiArticles && optiArticles.length > 0) {
      const arrayPost = [];
      for (let post of optiArticles) arrayPost.push(JSON.parse(post?.article));
      setArtigos(arrayPost);
    }
  }

  //useEffect(() => { getUserOpti('obter_usuario_opti') }, [])

  useEffect(() => {
    setGratuito(dataUser?.data?.perfis?.includes(5));
  }, [dataUser]);

  // useEffect(() => {
  //     if (userOpti?.data) {
  //         dispatch(store).setBlogIdOpti(parseInt(userOpti?.data?.idUsuarioWordpress))
  //         dispatch(store).setUsuarioIdOpti(parseInt(userOpti?.data?.idUsuarioOpti))
  //     }
  // }, [userOpti])

  useEffect(() => {
    populatePost();
  }, [optiArticles]);

  const validarArtigos = useCallback(async () => {
    if (dataIdsSelecionados && dataIdsSelecionados?.data?.length > 0 && optiArticles?.length > 0) {
      let reload = false;
      await mutateAsync({
        action: 'get_posts_selected',
        param: { ids: JSON.stringify(dataIdsSelecionados.data), publicado: 'true' },
      }).then(async res => {
        if (res.data.length != optiArticles.length)
          await obterSelecionados(idBlog).then(post => {
            post.data.forEach(async element => {
              if (
                res.data.filter(x => x.ID == element.idArtigoWp) != 0 &&
                optiArticles.filter(X => X.post_id == element.idArtigoWp) == 0
              ) {
                setRecadastrando(true);
                reload = true;
                await saveArticleOpti({
                  action: 'save_article',
                  postId: element.idArtigoWp,
                  article: JSON.stringify(element),
                });
              }
            });
          });
      });

      await mutateAsync({
        action: 'get_posts_selected',
        param: { ids: JSON.stringify(dataIdsSelecionados.data) },
      }).then(async res => {
        optiArticles.forEach(async element => {
          if (res.data.filter(x => x.ID == element.post_id) == 0) {
            setExcluir(true);
            reload = true;
            await saveArticleOpti({
              action: 'delete_article',
              postId: element.post_id,
            });
          }
        });
      });
      if (reload) location.reload();
    }
  }, [dataIdsSelecionados, optiArticles]);

  useEffect(() => {
    validarArtigos();
  }, [optiArticles]);

  const dashboardConfigurado = analytics => {
    return (
      <>
        {loading && <Loading />}
        {!loading && artigos.length > 0 && (
          <Dashboard
            analytics={analytics}
            artigos={artigos}
            postLength={dataIdsSelecionados?.data?.length}
            recadastrando={recadastrando}
            excluir={excluir}
          />
        )}
        {!loading && optiArticles && optiArticles.length === 0 && (
          <ContextChooseProvider>
            <ChooseArticles />
          </ContextChooseProvider>
        )}
      </>
    );
  };

  switch (currentRoute) {
    case '?page=logs':
      return <LogView />;

    case '?page=optimarketing&add=true':
      return (
        <>
          {(loading || isLoading) && <Loading />}
          {!loading &&
            dataIdsSelecionados &&
            dataIdsSelecionados?.data?.length > 0 &&
            dataIdsSelecionados?.data?.length < dataPlanoUsuario?.data?.quantidadeArtigos && (
              <ContextChooseProvider>
                <ChooseArticles />
              </ContextChooseProvider>
            )}
          {dataPlanoUsuario?.data?.quantidadeArtigos >= dataPlanoUsuario?.data?.quantidadeArtigos && dashboardConfigurado()}
        </>
      );
    case '?page=optimarketing':
      return dashboardConfigurado();
    case '?page=optimarketing&analytics=true':
      return dashboardConfigurado(true);
    case '?page=optimarketing&criar-artigo=true':
      return (
        <IntegracaoProvider>
          <ArtigoIA />
        </IntegracaoProvider>
      );
    case currentRoute.match(/^\?page=optimarketing&editar-artigo=\d+$/)?.input:
      const params = new URLSearchParams(location.search)
      const editarArtigo = parseInt(params.get('editar-artigo')) || 0
      return (
        <IntegracaoProvider>
          <ArtigoIA idRascunho={editarArtigo} />
        </IntegracaoProvider>
      );
  }
};
